const configuredThemes = {
    retro: {
        mediaAlign: 'left',
        textAlign: 'left',
    },
    'retro-variant': {
        mediaAlign: 'left',
        textAlign: 'center',
    },
    classic: {
        mediaAlign: 'center',
        textAlign: 'center',
    },
    'classic-variant': {
        mediaAlign: 'center',
        textAlign: 'left',
    },
    vintage: {
        mediaAlign: 'right',
        textAlign: 'right',
    },
    'vintage-variant': {
        mediaAlign: 'right',
        textAlign: 'center',
    },
    'left-top': {
        alignTheme: 'left-top',
    },
    'left-middle': {
        alignTheme: 'left-middle',
    },
    'left-bottom': {
        alignTheme: 'left-bottom',
    },
    'center-top': {
        alignTheme: 'center-top',
    },
    'center-middle': {
        alignTheme: 'center-middle',
    },
    'center-bottom': {
        alignTheme: 'center-bottom',
    },
    'right-top': {
        alignTheme: 'right-top',
    },
    'right-middle': {
        alignTheme: 'right-middle',
    },
    'right-bottom': {
        alignTheme: 'right-bottom',
    },
};
export default configuredThemes;
